import React, { useEffect } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { db, auth } from '../../firebase';
import { collection } from 'firebase/firestore';
import './HotelRooms.css';
import { Link, useNavigate } from 'react-router-dom';
// import Load from '../Loder/Load';

export const HotelRooms = () => {
  const navigate = useNavigate();
  const currentUser = auth.currentUser;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  const [Services, loading, error] = useCollection(collection(db, 'Rooms'));

  const truncateText = (text, maxLength) => {
    const words = text.split(' ');
    if (words.length > maxLength) {
      return words.slice(0, maxLength).join(' ') + '...';
    }
    return text;
  };

  return (
    <div className='hotel-rooms'>
      <div className='hotel-rooms-heading'> 
        <div className='hotel-rooms-subheading'>
          <p className="hotel-rooms-title">Our Rooms</p>
          <h1 className="hotel-rooms-title1"> <span className='hotel-rooms-title1-color'>Bunch of Rooms</span> to Rock Your Stay</h1>
        </div>
      </div>
      {loading && "LOading...."}
      {error && <p>Error fetching Rooms</p>}
      {Services && (
        <div className='hotel-rooms-section'>
          {Services.docs.map((Service) => {
            const data = Service.data();
            return (
              <Link key={Service.id} to={`/room/${Service.id}`} className='hotel-room-link'>
                <div className='hotel-room-card'>
                  <img loading="lazy" src={data.iconImageUrl} alt={data.title} className='hotel-room-image'/>
                  <div className='hotel-room-content'>
                    <h3 className='hotel-room-title'>{data.title}</h3>
                    <p className='hotel-room-description'>{truncateText(data.p1, 10)}</p>
                    {/* Book Now Button */}
                    <Link to={`/booking/${Service.id}`} className="hotel-book-now-btn">
                      Book Now
                    </Link>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};
